var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HouseLine"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 20.25V10.8317C20.25 10.7272 20.2282 10.6239 20.1859 10.5283C20.1436 10.4328 20.0818 10.3471 20.0045 10.2768L12.504 3.45787C12.3659 3.33236 12.186 3.26281 11.9995 3.26282C11.8129 3.26282 11.633 3.33238 11.4949 3.45791L3.99545 10.2768C3.91814 10.3471 3.85637 10.4328 3.8141 10.5283C3.77183 10.6239 3.75 10.7272 3.75 10.8317V20.25",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 20.25V10.8317C20.25 10.7272 20.2282 10.6239 20.1859 10.5283C20.1436 10.4328 20.0818 10.3471 20.0045 10.2768L12.504 3.45787C12.3659 3.33236 12.186 3.26281 11.9995 3.26282C11.8129 3.26282 11.633 3.33238 11.4949 3.45791L3.99545 10.2768C3.91814 10.3471 3.85637 10.4328 3.8141 10.5283C3.77183 10.6239 3.75 10.7272 3.75 10.8317V20.25",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 20.2493V14.9993C14.25 14.8004 14.171 14.6096 14.0303 14.4689C13.8897 14.3283 13.6989 14.2493 13.5 14.2493H10.5C10.3011 14.2493 10.1103 14.3283 9.96967 14.4689C9.82902 14.6096 9.75 14.8004 9.75 14.9993V20.2493",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 20.2493V14.9993C14.25 14.8004 14.171 14.6096 14.0303 14.4689C13.8897 14.3283 13.6989 14.2493 13.5 14.2493H10.5C10.3011 14.2493 10.1103 14.3283 9.96967 14.4689C9.82902 14.6096 9.75 14.8004 9.75 14.9993V20.2493",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1.5 20.25H22.5",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBlackIcon);
export default __webpack_public_path__ + "static/media/home-black-icon.f89d71dad633837fa7da5c4af1af4431.svg";
export { ForwardRef as ReactComponent };